import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './index.css';

class InputIconDecorator extends Component {
  static get propTypes() {
    return {
      className: PropTypes.string,
      iconVisible: PropTypes.bool,
      inputIcon: PropTypes.func,
      iconStyle: PropTypes.object,
      iconColor: PropTypes.string,
      onClick: PropTypes.func,
      style: PropTypes.object,
      children: PropTypes.any
    };
  }

  renderIcon() {
    const { inputIcon: Icon } = this.props;
    const iconStyle = this.props.onClick ? { ...this.props.iconStyle, cursor: 'pointer' } : this.props.iconStyle;

    return (
      <div className="input-icon-container">
        <Icon
          onClick={ this.props.onClick }
          style={ iconStyle }
          color={ this.props.iconColor }
          className={ classNames('input-icon', this.props.className) }
        />
      </div>
    );
  }

  render() {
    return (
      <div className="input-icon-decorator-component" style={ this.props.style }>
        { this.props.children }
        { this.props.iconVisible && this.renderIcon() }
      </div>
    );
  }
};

export default InputIconDecorator;